import axios from 'axios';

let isSetup = true;
export default ({ app }) => {
  app.router.afterEach(async (to, from) => {
    if (!isSetup) {
      const newPath = await axios.post('/route-check', { route: to.path }).then((res) => res.data);

      if (newPath) {
        await app.router.push(newPath);
      }
    }
    isSetup = false;
  });
};
